<template>
  <div>
    <b-card
      header-tag="header"
      footer-tag="footer"
    >
      <div slot="header">
        <i
          class="fa fa-paper-plane"
          aria-hidden="true"
        ></i>
        New Message
        <div class="card-header-actions">
          <a
            href="https://bootstrap-vue.js.org/docs/components/progress"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </div>
      <div>
        <b-row>
          <b-col sm="12">
            <b-alert class="text-center" :show="successMessage != ''" variant="success"> {{ successMessage }} </b-alert>
            <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
            <!-- Send to -->
            <b-form-group>
              <label for="sendTo">Send to</label>
              <b-input-group>
                <b-input-group-prepend>
                  <b-dropdown
                    :text="form.sendType"
                    variant="secondary"
                  >
                    <b-dropdown-item @click="form.sendType = 'token'">Token</b-dropdown-item>
                    <b-dropdown-item @click="form.sendType = 'refId'">Ref ID</b-dropdown-item>
                    <b-dropdown-item @click="form.sendType = 'tag'">Tag</b-dropdown-item>
                  </b-dropdown>
                </b-input-group-prepend>
                <b-form-input
                  v-model="form.sendTo"
                  :placeholder="sendTypePlaceHolder"
                ></b-form-input>
                <b-form-invalid-feedback :state="true">
                  Please provide a valid information.
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>

            <!-- Api Key-->
            <b-form-group>
              <label for="sendTo">Api Key</label>
              <b-form-input
                v-model="form.apiKey"
                placeholder="Enter Api key"
              ></b-form-input>
              <b-form-invalid-feedback :state="true">
                Please provide a api key.
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Secret Key-->
            <b-form-group>
              <label for="sendTo">Secret</label>
              <b-form-input
                v-model="form.secret"
                placeholder="Enter secret key"
              ></b-form-input>
              <b-form-invalid-feedback :state="true">
                Please provide a secret key.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
              <label>Platform</label>
              <b-form-select v-model="form.platform">
                <option value="all">All</option>
                <option value="ios">iOS</option>
                <option value="android">Android</option>
              </b-form-select>
            </b-form-group>

            <!-- Topic -->
            <b-form-group>
              <label for="sendTo">Topic</label>
              <b-form-input
                v-model="form.topic"
                placeholder="Enter topic you need to send"
              ></b-form-input>
              <b-form-invalid-feedback :state="true">
                Please provide a valid information.
              </b-form-invalid-feedback>
            </b-form-group>

            <!-- Message  -->
            <b-form-group>
              <label for="sendTo">Message</label>
              <b-form-textarea
                v-model="form.message"
                placeholder="Enter message you need to send"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <b-form-invalid-feedback :state="true">
                Please provide a valid information.
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group>
              <b-form-checkbox
                v-model="form.isManualPayload"
              >
                use manual payload
              </b-form-checkbox>
            </b-form-group>

            <!-- payload -->
            <b-form-group v-show="form.isManualPayload">
              <label for="sendTo">Payload</label>
              <b-form-textarea
                v-model="form.payload"
                placeholder="Enter your payload (only support JSON object)"
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              <b-form-invalid-feedback :state="true">
                Please provide a valid information.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div slot="footer">
        <b-button
          @click="Send"
          class="mr-2"
          type="submit"
          size="sm"
          variant="primary"
        >
          <i class="fa fa-dot-circle-o"></i>
          Send
        </b-button>
        <b-button
          disabled
          class="mr-2"
          type="button"
          size="sm"
          variant="success"
        >
          <i class="fa fa-dot-circle-o"></i>
          Save
        </b-button>
        <b-button
          @click="setDefaults"
          type="reset"
          size="sm"
          variant="danger"
        >
          <i class="fa fa-ban"></i>
          Reset
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      sendType: 'token',
      sendTypePlaceHolder: 'Enter tokens need to send',
      errorMessage: '',
      successMessage: '',
      tagType: 'and',
      selectedApp: null,
      options: [{ value: null, text: 'select app to send' }],
      form: {},
      tagTest: '',
      tags: []
    };
  },
  watch: {
    sendType () {
      if ('token' === this.sendType) {
        this.sendTypePlaceHolder = 'Enter array of tokens need to send';
      } else if ('refId' === this.sendType) {
        this.sendTypePlaceHolder = 'Enter array of refIds need to send';
      } else if ('groupId' === this.sendType) {
        this.sendTypePlaceHolder = 'Enter groupId need to send';
      }
    }
  },
  methods: {
    setDefaults () {
      this.form = {};
      this.from.isManualPayload = false;
      this.sendType = 'token';
      this.tagType = 'and';
      this.selectedApp = null;
    },
    getApiKey () {
      this.list = [];
      this.isBusy = true;
      this.axios.get(process.env.VUE_APP_URL_UNIVERSAL_API + '/messaging/api-keys',
        {
          params: { page: this.currentPage }
        })
        .then(response => {
          const data = response.data ? response.data.data : null;
          if (!data) {
            throw new Error('Data not found');
          }
          for (const apiKey of data) {
            this.options.push({
              value: {
                apiKey: apiKey.apiKey,
                username: apiKey.username
              },
              text: apiKey.app
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    Send () {
      let jsonToPost = {};

      let tokens = [];
      let payload = {
        name: 'John Wick'
      };
      if (this.form.isManualPayload) {
        try {
          payload = JSON.parse(this.form.payload);
        } catch (error) {
          console.log(error);
          this.successMessage = '';
          // eslint-disable-next-line no-return-assign
          return this.errorMessage = '[payload] is wrong json format!';
        }
      }
      tokens.push(this.form.sendTo);
      jsonToPost = {
        secret: this.form.secret,
        to: {
          type: this.form.sendType,
          platform: this.form.platform,
          value: tokens
        },
        notification: {
          title: this.form.topic,
          message: this.form.message,
          badge: 1,
          payload: payload
        }
      };

      this.axios.post(`${process.env.VUE_APP_URL_MESSAGING_API}/notification/send?api-key=${this.form.apiKey}`, jsonToPost)
        .then(res => {
          const respData = res.data;
          if ('Success' === respData.message) {
            this.successMessage = 'Notification sent successfully';
            this.errorMessage = '';
          }
        })
        .catch(error => {
          console.log('Error :', error.response);
          this.successMessage = '';
          if ('UAT-003' === error.response.data.code) {
            this.$router.push({ name: 'login' });
          }
          this.errorMessage = error.response.data.data.map(value => value.msg).join(', ');
        });
    }
  },
  created () {
    this.getApiKey();
    document.title = 'Admin Console: Messaging Send Notification';
  }
};
</script>

<style scoped>
.tags {
  width: 100%;
  max-width: none;
  font-size: 14px;
}
</style>

<style>
.ti-new-tag-input-wrapper {
  font-size: 14px !important;
}
li.ti-valid {
  background-color: #20a8d8 !important;
}
li.ti-deletion-mark {
  background-color: #f86c6b !important;
}
</style>
